import cleanedFilename from '~/util/cleanedFilename';

export default {
  NAME: `${cleanedFilename(__filename)}-name`,
  DESCRIPTION: `${cleanedFilename(__filename)}-description`,
  ENABLED: `${cleanedFilename(__filename)}-enabled`,
  ACTION: `${cleanedFilename(__filename)}-action`,
  SHARED_COLUMN: `${cleanedFilename(__filename)}-shared-column`,
  STATISTICS: `${cleanedFilename(__filename)}-statistics`,
  CREATED: `${cleanedFilename(__filename)}-created`,
  LAST_MODIFIED: `${cleanedFilename(__filename)}-last-modified`,
  CHECKBOX: `${cleanedFilename(__filename)}-checkbox`,
};
